module.exports = __webpack_public_path__ + "img/logo-besttutor.619de449.png";